<!--- Mobile --->
<div class="d-lg-none dropdown" dropdown [dropup]="true">
    <button
        class="btn btn-secondary nav-item btn-lg w-100"
        type="button"
        [tooltip]="'F4M_TOOLTIP_FILTER_VISIBLE_CHECKPOINTS_BY_TYPE' | translate"
        aria-label="'F4M_TOOLTIP_FILTER_VISIBLE_CHECKPOINTS_BY_TYPE' | translate"
        dropdownToggle
        #tooltip="bs-tooltip"
        placement="bottom"
        (click)="$event.stopPropagation(); tooltip.hide()"
    >
        <fa-icon [icon]="faFilter"></fa-icon> <span class="ms-2" [translate]="'FORM_FILTER_HEADER'"></span>
    </button>
    <ul class="dropdown-menu navbar-dropdown" role="menu" *dropdownMenu>
        @for (entry of typeFilterItems$ | async; track entry.elementType) {
            <li role="menuitem">
                <a
                    class="dropdown-item py-2"
                    (click)="onTypeFilterSelected($event, entry)"
                    [ngClass]="{ 'highlight-selection': entry.visible }"
                    >{{ entry.label }}
                    @if (entry.visible) {
                        <span class="ps-2"><fa-icon [icon]="faEye"></fa-icon></span>
                    }
                </a>
            </li>
        }
        @for (formFilter of formFilterItem$ | async; track formFilter.filterType) {
            <li role="menuitem">
                <a
                    class="dropdown-item py-2"
                    (click)="onFormFilterSelected($event, formFilter)"
                    [ngClass]="{ 'highlight-selection': formFilter.visible }"
                    >{{ formFilter.label | translate }}
                    @if (formFilter.visible) {
                        <span class="ps-2"><fa-icon [icon]="faEye"></fa-icon></span>
                    }
                </a>
            </li>
        }
    </ul>
</div>

<!--- Desktop --->
<div class="d-none d-lg-block dropdown" dropdown [dropup]="true">
    <button
        class="btn btn-secondary nav-item"
        type="button"
        [tooltip]="'F4M_TOOLTIP_FILTER_VISIBLE_CHECKPOINTS_BY_TYPE' | translate"
        aria-label="'F4M_TOOLTIP_FILTER_VISIBLE_CHECKPOINTS_BY_TYPE' | translate"
        dropdownToggle
        #tooltip="bs-tooltip"
        (click)="tooltip.hide()"
    >
        <fa-icon [icon]="faFilter"></fa-icon>
    </button>
    <ul class="dropdown-menu navbar-dropdown" role="menu" *dropdownMenu>
        @for (entry of typeFilterItems$ | async; track entry.elementType) {
            <li role="menuitem">
                <a
                    class="dropdown-item"
                    (click)="onTypeFilterSelected($event, entry)"
                    [ngClass]="{ 'highlight-selection': entry.visible }"
                    >{{ entry.label }}
                    @if (entry.visible) {
                        <span class="ps-2"><fa-icon [icon]="faEye"></fa-icon></span>
                    }
                </a>
            </li>
        }
        @for (formFilter of formFilterItem$ | async; track formFilter.filterType) {
            <li role="menuitem">
                <a
                    class="dropdown-item"
                    (click)="onFormFilterSelected($event, formFilter)"
                    [ngClass]="{ 'highlight-selection': formFilter.visible }"
                    >{{ formFilter.label | translate }}
                    @if (formFilter.visible) {
                        <span class="ps-2"><fa-icon [icon]="faEye"></fa-icon></span>
                    }
                </a>
            </li>
        }
    </ul>
</div>
